module.exports = __webpack_public_path__ + "static/media/dot.11a327aa.svg";